import { Global } from "./general";
const info = Global.info;
export default function headerRequest() {
  let user = JSON.parse(localStorage.getItem(info));
  if (user && user.token) {
    return { 'Authorization': "Bearer " + user.token };
  }
}